export interface IGame {
  type: GameTypeEnum;
  choice: ChoiceTypeEnum;
  count: number;
  amount: number;
}

export enum GameTypeEnum {
  KNB = 'KNB',
  HOT = 'HOT',
}

export enum ChoiceTypeEnum {
  ROCK = 'ROCK',
  SCISSORS = 'SCISSORS',
  PAPER = 'PAPER',
  DICE = 'DICE',
  HEADS = 'HEADS',
  TAILS = 'TAILS',
}

export enum GameStatusEnum {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
}

export interface IGameItem {
  gameId: string;
  betAmount: number;
  ownerName: string;
  ownerId: string;
  ownerChoice?: ChoiceTypeEnum;
  playerName?: string;
  playerId?: string;
  playerChoice?: ChoiceTypeEnum;
  winnerName?: string;
  winnerId?: string;
  md5: string;
  type: GameTypeEnum;
  status: GameStatusEnum;
  createdAt: string;
  updateAt?: string;
  isOwner?: boolean;
  selectedChoice?: ChoiceTypeEnum;
  isWinner?: boolean;
  isMember?: boolean;
  colorResult?: string;
  titleResult?: string;
}
